export enum APP_ROUTES {
    API_LOG = 'api-log',
    AUTHORITIES = 'authorities',
    BRANDS = 'brands',
    CONGO_SUMMARY = 'congo-summary',
    CRITICAL_ALERT_HISTORY = 'critical-alert-history',
    DASHBOARD = 'dashboard',
    ERROR = 'error',
    LOAD_DATA = 'load-data',
    LOGIN = 'login',
    MALAWI_SUMMARY = 'malawi-summary',
    NOTIFICATION_HISTORY = 'notification-history',
    ONLINE_MALAWI = 'online-malawi',
    REPORTS_LOG = 'reports-log',
    ROOT = '',
    RWANDA_SUMMARY = 'rwanda-summary',
    SAVE_SEARCH = 'save-search',
    SETTINGS = 'settings',
    SUMMARY_REPORT = 'summary-report',
    SUMMARY_REPORT_BURUNDI = 'summary-report-burundi',
    SUMMARY_REPORT_ZAMBIA = 'summary-report-zambia',
    SUMMARY_REPORT_ZIMBABWE = 'summary-report-zimbabwe',
    SUMMARY_REPORT_ZIMBABWEMWOS = 'summary-report-zimbabwemwos',
    TANZANIA_SUMMARY = 'tanzania-summary',
    TAX_REPORTING = 'tax-reporting',
    TOTAL_REPORT = 'total-report',
    TOTAL_REPORT_BURUNDI = 'total-report-burundi',
    TOTAL_REPORT_CONGO = 'total-report-congo',
    TOTAL_REPORT_RWANDA = 'total-report-rwanda',
    TOTAL_REPORT_TANZANIA = 'total-report-tanzania',
    TOTAL_REPORT_UGANDA = 'total-report-uganda',
    TOTAL_REPORT_ZAMBIA = 'total-report-zambia',
    TOTAL_REPORT_ZIMBABWE = 'total-report-zimbabwe',
    TOTAL_REPORT_ZIMBABWEMWOS = 'total-report-zimbabwemwos',
    USER_SUMMARY_REPORT = 'user-summary-report',
    USER_LOGS_HISTORY = 'user-logs-history',
}
